"use strict";
exports.__esModule = true;
var angular = require("angular");
var inav_version_1 = require("./inav-version");
var xnav_version_1 = require("./xnav-version");
var pnav_version_1 = require("./pnav-version");
console.log('🔍 DEBUG: version-service.ts - File loading started');
// Register the version service with the smartorg.r6 module
angular.module('smartorg.r6').service('versionService', [function () {
        console.log('🔍 DEBUG: version-service.ts - Service constructor called');
        var self = this;
        /**
         * Get the product type from server configuration data
         */
        this.getProductTypeFromConfig = function (serverConfig) {
            console.log('🔍 DEBUG: version-service.ts - Getting product type from server config:', serverConfig);
            try {
                // PRIORITY 1: Check for direct productType field first (new implementation)
                if (serverConfig.productType) {
                    var productType = serverConfig.productType.toString().toLowerCase();
                    console.log('🔍 DEBUG: version-service.ts - Product type from serverConfig.productType:', productType);
                    // Validate and normalize productType
                    if (['pnav', 'inav', 'xnav'].includes(productType)) {
                        return productType.toUpperCase();
                    }
                    else {
                        console.warn('🔍 DEBUG: version-service.ts - Invalid productType value:', productType, 'defaulting to PNAV');
                        return 'PNAV';
                    }
                }
                // PRIORITY 2: Check for legacy boolean flags (backward compatibility)
                if (serverConfig.isInav) {
                    console.log('🔍 DEBUG: version-service.ts - Product type detected as INAV from legacy serverConfig.isInav');
                    return 'INAV';
                }
                if (serverConfig.isCorteva) {
                    console.log('🔍 DEBUG: version-service.ts - Product type detected as XNAV from legacy serverConfig.isCorteva');
                    return 'XNAV';
                }
                // PRIORITY 3: Fallback to URL-based detection
                console.log('🔍 DEBUG: version-service.ts - No product type in server config, falling back to URL detection');
                var hostname = window.location.hostname.toLowerCase();
                if (hostname.includes('inav')) {
                    console.log('🔍 DEBUG: version-service.ts - Product type detected as INAV from URL');
                    return 'INAV';
                }
                if (hostname.includes('xnav') || hostname.includes('corteva')) {
                    console.log('🔍 DEBUG: version-service.ts - Product type detected as XNAV from URL');
                    return 'XNAV';
                }
                // Default to PNAV
                console.log('🔍 DEBUG: version-service.ts - Defaulting to PNAV product type');
                return 'PNAV';
            }
            catch (error) {
                console.error('🔍 DEBUG: version-service.ts - Error analyzing server config:', error);
                console.log('🔍 DEBUG: version-service.ts - Defaulting to PNAV due to error');
                return 'PNAV';
            }
        };
        /**
         * Get version data based on server configuration
         */
        this.getVersionDataFromConfig = function (serverConfig) {
            console.log('🔍 DEBUG: version-service.ts - Getting version data from server config');
            var productType = self.getProductTypeFromConfig(serverConfig);
            console.log('🔍 DEBUG: version-service.ts - Product type determined:', productType);
            var versionData;
            switch (productType) {
                case 'INAV':
                    versionData = inav_version_1.inavVersionData;
                    break;
                case 'XNAV':
                    versionData = xnav_version_1.xnavVersionData;
                    break;
                case 'PNAV':
                default:
                    versionData = pnav_version_1.pnavVersionData;
                    break;
            }
            console.log('🔍 DEBUG: version-service.ts - Version data loaded:', versionData);
            return versionData;
        };
        /**
         * Get version data (fallback method for backward compatibility)
         */
        this.getVersionData = function () {
            console.log('🔍 DEBUG: version-service.ts - Getting version data (fallback method)');
            // Fallback to URL-based detection if no server config provided
            var hostname = window.location.hostname.toLowerCase();
            var productType = 'PNAV';
            if (hostname.includes('inav')) {
                productType = 'INAV';
            }
            else if (hostname.includes('xnav') || hostname.includes('corteva')) {
                productType = 'XNAV';
            }
            console.log('🔍 DEBUG: version-service.ts - Product type determined from URL:', productType);
            var versionData;
            switch (productType) {
                case 'INAV':
                    versionData = inav_version_1.inavVersionData;
                    break;
                case 'XNAV':
                    versionData = xnav_version_1.xnavVersionData;
                    break;
                case 'PNAV':
                default:
                    versionData = pnav_version_1.pnavVersionData;
                    break;
            }
            console.log('🔍 DEBUG: version-service.ts - Version data loaded (fallback):', versionData);
            return Promise.resolve(versionData);
        };
        console.log('🔍 DEBUG: version-service.ts - Service initialized');
    }]);
console.log('🔍 DEBUG: version-service.ts - Module registration complete');
//# sourceMappingURL=version-service.js.map


// WEBPACK FOOTER //
// ./app/version-service.js